var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vg-card',[_c('vg-form',_vm._l((_vm.profitCenters),function(profitCenter){return _c('vg-field',{key:profitCenter.profitCenterId,attrs:{"label":profitCenter.projectName,"is-link":""},on:{"click":function($event){return _vm.pick(profitCenter)}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }